import * as sushiData from "@sushiswap/sushi-data";

export default class SushiSwapService {
  getTokenData = async (address: string): Promise<any> => {
    return sushiData.exchange.token24h({ token_address: address });
  };

  getEthPrice = async (): Promise<any> => {
    return sushiData.exchange.ethPrice();
  };
}
